export default {"src":"/_next/static/media/moreIcon2.49d2e092.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};